import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Boothfee } from './boothfee.model';
import { BoothfeePopupService } from './boothfee-popup.service';
import { BoothfeeService } from './boothfee.service';

@Component({
    selector: 'jhi-boothfee-delete-dialog',
    templateUrl: './boothfee-delete-dialog.component.html'
})
export class BoothfeeDeleteDialogComponent {

    boothfee: Boothfee;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private boothfeeService: BoothfeeService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['boothfee']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.boothfeeService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'boothfeeListModification',
                content: 'Deleted an boothfee'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-boothfee-delete-popup',
    template: ''
})
export class BoothfeeDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private boothfeePopupService: BoothfeePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.boothfeePopupService
                .open(BoothfeeDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee-delete-dialog.component.ts